export default __webpack_public_path__ + "static/media/logo.edfc1081.png";